'use client';
import Link from 'next/link';
import { useSearchParams } from 'next/navigation';
import { Company } from '~/types/job-detail';

// コンポーネント内に設定内容を定義
const localSettings = {
  company: {
    information_table_at_show: {
      name: '会社名',
      url: '会社HP',
      address: '住所',
      members: '従業員数',
      revenue: '売上高',
      capital: '資本金',
      founded: '設立',
      detail: '詳細説明',
      feature: '会社の特徴',
    },
  },
};

interface CompanyInformationPanelProps {
  company: Company;
}

export function CompanyInformationPanel({
  company,
}: CompanyInformationPanelProps) {
  // URLのクエリパラメータから action を取得
  const searchParams = useSearchParams();
  const action = searchParams.get('action') || '';

  const informationTable = localSettings.company.information_table_at_show;

  return (
    <div className="c-panel -job-detail">
      <div className="u-pl20 u-pr20">
        <h2 className="c-panel__header">会社概要</h2>
        <div className="c-panel__body">
          <div className="p-job-detail__information">
            <div className="p-job-detail__information-table">
              {Object.entries(informationTable).map(([paramKey, label]) => {
                const key = paramKey as keyof Company;
                if (!company[key]) return null;

                return (
                  <div
                    className="p-job-detail__information-table-row"
                    key={paramKey}
                  >
                    <div className="p-job-detail__information-table-header">
                      <p className="u-font-bold p-job-detail__heading">
                        {label}
                      </p>
                    </div>
                    <div className="p-job-detail__information-table-content">
                      {label === '会社名' ? (
                        action === 'private_show' || company.hidden ? (
                          <>{company.name}</>
                        ) : (
                          <Link
                            href={`/companies/${company.id}`}
                            prefetch={false}
                          >
                            {company.name}
                          </Link>
                        )
                      ) : label === '会社HP' ? (
                        <a
                          href={company.url}
                          rel="nofollow noopener noreferrer"
                          target="_blank"
                        >
                          {company.url}
                        </a>
                      ) : (
                        <div> {String(company[key])} </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
